"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.getStates = exports.getCountries = exports.ACTIONS = void 0;

var _ = require(".");

var _spec = require("./spec");

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  pendingRequests: 0,
  errors: {},
  countries: {},
  states: {},
  isLoading: false
};
var ACTIONS = {
  GET_COUNTRIES: new _.APIAction('GET_COUNTRIES'),
  GET_STATES: new _.APIAction('GET_STATES')
};
exports.ACTIONS = ACTIONS;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentPendingRequests;

  switch (action.type) {
    case ACTIONS.GET_COUNTRIES.main:
    case ACTIONS.GET_STATES.main:
      currentPendingRequests = state.pendingRequests + 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.GET_COUNTRIES.success:
      currentPendingRequests = state.pendingRequests - 1;
      var countriesByKey = (0, _lodash.keyBy)(action.payload.results, 'code');
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        countries: countriesByKey,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.GET_STATES.success:
      currentPendingRequests = state.pendingRequests - 1;
      var statesByKey = (0, _lodash.keyBy)(action.payload.results, 'code');
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        states: statesByKey,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.GET_COUNTRIES.fail:
    case ACTIONS.GET_STATES.fail:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: action.payload,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    default:
      return state;
  }
}

var getCountries = function getCountries(params) {
  return {
    type: ACTIONS.GET_COUNTRIES.main,
    payload: {
      request: {
        url: _spec.GEO_ENDPOINTS.GET_COUNTRIES,
        method: 'GET',
        params: params
      }
    }
  };
};

exports.getCountries = getCountries;

var getStates = function getStates(params) {
  return {
    type: ACTIONS.GET_STATES.main,
    payload: {
      request: {
        url: _spec.GEO_ENDPOINTS.GET_STATES,
        method: 'GET',
        params: params
      }
    }
  };
};

exports.getStates = getStates;